(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function parseEndDate(value) {
    if (!value) return null;
    var parsed = new Date(value).getTime();
    return Number.isNaN(parsed) ? null : parsed;
  }

  function initGlobalCountdown(root) {
    var countdown = root.querySelector('[data-hos-countdown]');
    if (!countdown) return;

    var target = parseEndDate(countdown.getAttribute('data-end-date'));
    if (!target) return;

    var daysEl = countdown.querySelector('[data-hos-days]');
    var hoursEl = countdown.querySelector('[data-hos-hours]');
    var minutesEl = countdown.querySelector('[data-hos-minutes]');
    var secondsEl = countdown.querySelector('[data-hos-seconds]');

    function tick() {
      var distance = target - Date.now();
      if (distance <= 0) {
        countdown.classList.add('is-expired');
        return false;
      }

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
      return true;
    }

    if (!tick()) return;
    var timer = window.setInterval(function () {
      if (!tick()) window.clearInterval(timer);
    }, 1000);
  }

  function initCarousel(root) {
    var carouselEl = root.querySelector('[data-hos-carousel]');
    if (!carouselEl || typeof Swiper === 'undefined') return;

    var cols = parseInt(root.getAttribute('data-hos-cols') || '4', 10);
    if (Number.isNaN(cols) || cols < 2) cols = 4;

    new Swiper(carouselEl, {
      slidesPerView: 1.45,
      spaceBetween: 4,
      speed: 420,
      watchOverflow: true,
      grabCursor: true,
      navigation: {
        nextEl: root.querySelector('[data-hos-next]'),
        prevEl: root.querySelector('[data-hos-prev]'),
      },
      breakpoints: {
        480: {
          slidesPerView: 2.2,
          spaceBetween: 4,
        },
        750: {
          slidesPerView: Math.min(3, cols),
          spaceBetween: 6,
        },
        990: {
          slidesPerView: cols,
          spaceBetween: 6,
        },
      },
    });
  }

  function init(root) {
    if (!root || root.dataset.hosReady === 'true') return;
    root.dataset.hosReady = 'true';
    initGlobalCountdown(root);
    initCarousel(root);
  }

  function boot() {
    document.querySelectorAll('[data-home-offers-sale]').forEach(init);
  }

  function waitForSwiper(attempt) {
    if (typeof Swiper !== 'undefined') {
      boot();
      return;
    }
    if (attempt > 40) {
      boot();
      return;
    }
    window.setTimeout(function () {
      waitForSwiper(attempt + 1);
    }, 50);
  }

  document.addEventListener('DOMContentLoaded', function () {
    waitForSwiper(0);
  });
})();
